import preQuizOne from './preQuizOne';
// import preQuizTwo from './preQuizTwo';
// import preQuizThree from './preQuizThree';

export default {
  title: 'Pre-Quiz',
  children: [preQuizOne, /* preQuizTwo, preQuizThree */ ]
};



// WEBPACK FOOTER //
// ./src/data/Pre-Quiz/index.js